import request from "@/utils/request"
// 获取用电记录
export function getDevUseElecPageList(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetDevUseElecPageList",
    method: "post",
    data
  })
}
// 用电记录统计信息
export function GetDevUseElecStatisticInfo(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetDevUseElecStatisticInfo",
    method: "post",
    data
  })
}

// 充电订单
export function GetDevChargeOrderPageList(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetDevChargeOrderPageList",
    method: "post",
    data
  })
}

// 充电订单统计
export function GetDevChargeOrderStatisticInfo(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetDevChargeOrderStatisticInfo",
    method: "post",
    data
  })
}
// 设备余额
export function GetDevBalancePageList(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetDevBalancePageList",
    method: "post",
    data
  })
}

// 设备故障
export function GetDevFaultPageList(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetDevFaultPageList",
    method: "post",
    data
  })
}
// 调控记录
export function GetCtrStrateLogPageList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/CtrStrateLog/GetPageList",
    method: "post",
    data
  })
}

//分页查询商户列表
export function GetMerchantPageList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Merchant/GetPageList",
    method: "post",
    data
  })
}
//添加商户
export function AddMerchant(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Merchant/Add",
    method: "post",
    data
  })
}
//修改商户

export function UpdateMerchant(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Merchant/Update",
    method: "post",
    data
  })
}

//删除商户

export function DeleteMerchant(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Merchant/Delete",
    method: "post",
    data
  })
}

//分页查询微信用户
export function GetJngWxUserPageList(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/JngWxUser/GetPageList",
    method: "get",
    params
  })
}

//设备状态功率曲线
export function GetPlatFormHisList(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetPlatFormHisList",
    method: "post",
    data
  })
}
//用户曲线
export function GetAcHisList(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetAcHisList",
    method: "post",
    data
  })
}

/** 获取扫码富商户列表 */
export function getSaccPayeeInfoAllList(params) {
  return request({
    url: "/Anno.Plugs.LhPayView/LhPayView/GetSaccPayeeInfoAllList",
    method: "get",
    params
  })
}

/* ==================== 子商户关联站点 ==================== */
// 说明：以下接口为前后端约定好的假请求路径，服务端接口就绪后按此路径实现即可

// 分页查询子商户已关联的站点列表
// 入参：{ merchant_id, site_name, page, pagesize, type }
// 返回：{ data: [], total: 0 }
export function GetSubMerchantSitePageList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Merchant/GetMerchantSitePageList",
    method: "post",
    data
  })
}

// 新增子商户关联站点
// 入参：{ merchant_id, siteIds: [], type }
export function AddSubMerchantSite(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/Merchant/AddMerchantSite",
    method: "get",
    params
  })
}

// 删除子商户关联站点
// 入参：{ ID, merchant_id, site_id, type }
export function DeleteSubMerchantSite(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/Merchant/DelMerchantSite",
    method: "get",
    params
  })
}

// 分页查询指定主商户下的所有站点（用于关联站点选择弹窗）
// 入参：{ main_merchant_id, site_name, page, pagesize }
// 返回：{ data: [], total: 0 }
export function GetMainMerchantSitePageList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Merchant/GetMerchantSitePageList",
    method: "post",
    data
  })
}
